import React, { useState } from 'react';
import { useMask } from '@react-input/mask';
import '../styles/ConsultaBoleto.css';
import logoProtseg from '../assets/protseg.png';

const ConsultaBoleto = () => {
  const [tipoConsulta, setTipoConsulta] = useState('1');
  const [valorConsulta, setValorConsulta] = useState('');
  const [loading, setLoading] = useState(false);
  const [resultado, setResultado] = useState(null);
  const [erro, setErro] = useState(null);
  const [historico, setHistorico] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);

  const [loadingVeiculos, setLoadingVeiculos] = useState(false);
  const [resultadoVeiculos, setResultadoVeiculos] = useState(null);
  const [erroVeiculos, setErroVeiculos] = useState(null);
  const [modalVeiculosAberto, setModalVeiculosAberto] = useState(false);

  const [modalAssistenciaAberto, setModalAssistenciaAberto] = useState(false);

  const [loadingQuit, setLoadingQuit] = useState(false);
  const [resultadoQuit, setResultadoQuit] = useState(null);
  const [erroQuit, setErroQuit] = useState(null);
  const [modalQuitAberto, setModalQuitAberto] = useState(false);
  const [placaQuit, setPlacaQuit] = useState('');

  const API_URL = 'https://avsegboletos.i9app.inf.br/boletoprotseg';
  const API_VEICULOS_URL = 'https://avsegboletos.i9app.inf.br/veiculosret';
  const API_QUIT_URL = 'https://avsegboletos.i9app.inf.br/boletosprotsegquit';
  const TOKEN = 'd1594a59c36b49f1b6e19dbb88fef602';

  const cpfInputRef = useMask({
    mask: '___.___.___-__',
    replacement: { _: /\d/ },
  });

  const cnpjInputRef = useMask({
    mask: '__.___.___/____-__',
    replacement: { _: /\d/ },
  });

  const formatarValor = (valor) => {
    return valor.replace(/\D/g, '');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (tipoConsulta === '2' || tipoConsulta === '3') {
      await handleConsultaVeiculos();
    } else {
      await handleConsulta();
    }
  };

  const handleConsulta = async () => {
    setLoading(true);
    setErro(null);
    setResultado(null);

    try {
      const payload = {
        token: TOKEN,
        tipo: tipoConsulta,
        cpf: tipoConsulta === '2' ? formatarValor(valorConsulta) : '',
        cnpj: tipoConsulta === '3' ? formatarValor(valorConsulta) : '',
        placa: tipoConsulta === '1' ? valorConsulta.toUpperCase().replace(/[^A-Z0-9]/g, '') : ''
      };

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const text = await response.text();
        console.error('Resposta não-OK da API:', response.status, text.substring(0, 200));
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      console.log('Resposta bruta da API:', text.substring(0, 500));
      const data = JSON.parse(text);

      if (data.status === 'ok') {
        setResultado(data);
        adicionarAoHistorico({
          tipo: tipoConsulta,
          valor: valorConsulta,
          data: new Date(),
          qtdVeiculos: data.veiculos?.length || 0
        });
      } else {
        setErro(data.mensagem || 'Erro ao consultar');
      }
    } catch (error) {
      setErro('Erro ao conectar com a API: ' + error.message);
    } finally {
      setLoading(false);
      setModalAberto(true);
    }
  };

  const handleConsultaVeiculos = async () => {
    setLoadingVeiculos(true);
    setErroVeiculos(null);
    setResultadoVeiculos(null);

    try {
      const payload = {
        token: TOKEN,
        cpf: tipoConsulta === '2' ? valorConsulta : '',
        cnpj: tipoConsulta === '3' ? valorConsulta : '',
      };

      const response = await fetch(API_VEICULOS_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const text = await response.text();
        console.error('Resposta não-OK da API Veículos:', response.status, text.substring(0, 200));
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      console.log('Resposta bruta da API Veículos:', text.substring(0, 500));
      const data = JSON.parse(text);

      if (data.status === 'Ok') {
        setResultadoVeiculos(data);
      } else {
        setErroVeiculos(data.mensagem || 'Erro ao consultar veículos');
      }
    } catch (error) {
      setErroVeiculos('Erro ao conectar com a API: ' + error.message);
    } finally {
      setLoadingVeiculos(false);
      setModalVeiculosAberto(true);
    }
  };

  const consultarBoletoPorPlaca = async (placa) => {
    setModalVeiculosAberto(false);
    setLoading(true);
    setErro(null);
    setResultado(null);

    try {
      const payload = {
        token: TOKEN,
        tipo: '1',
        cpf: '',
        cnpj: '',
        placa: placa.toUpperCase().replace(/[^A-Z0-9]/g, '')
      };

      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const text = await response.text();
        console.error('Resposta não-OK da API:', response.status, text.substring(0, 200));
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      console.log('Resposta bruta da API:', text.substring(0, 500));
      const data = JSON.parse(text);

      if (data.status === 'ok') {
        setResultado(data);
        adicionarAoHistorico({
          tipo: '1',
          valor: placa,
          data: new Date(),
          qtdVeiculos: data.veiculos?.length || 0
        });
      } else {
        setErro(data.mensagem || 'Erro ao consultar');
      }
    } catch (error) {
      setErro('Erro ao conectar com a API: ' + error.message);
    } finally {
      setLoading(false);
      setModalAberto(true);
    }
  };

  const consultarPgtosRealizados = async (placa) => {
    setPlacaQuit(placa);
    setLoadingQuit(true);
    setErroQuit(null);
    setResultadoQuit(null);

    try {
      const payload = {
        token: TOKEN,
        placa: placa,
      };

      const response = await fetch(API_QUIT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const text = await response.text();
      const data = JSON.parse(text);

      console.log('Resposta boletosprotsegquit:', JSON.stringify(data).substring(0, 500));
      if (data.status === 'Ok') {
        if (typeof data.titulos === 'string') {
          data.titulos = JSON.parse(data.titulos);
        }
        setResultadoQuit(data);
      } else {
        setErroQuit(data.mensagem || 'Erro ao consultar pagamentos realizados');
      }
    } catch (error) {
      setErroQuit('Erro ao conectar com a API: ' + error.message);
    } finally {
      setLoadingQuit(false);
      setModalQuitAberto(true);
    }
  };

  const fecharModalQuit = () => {
    setModalQuitAberto(false);
    setResultadoQuit(null);
    setErroQuit(null);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setResultado(null);
    setErro(null);
  };

  const fecharModalVeiculos = () => {
    setModalVeiculosAberto(false);
    setResultadoVeiculos(null);
    setErroVeiculos(null);
  };

  const adicionarAoHistorico = (consulta) => {
    const novoHistorico = [consulta, ...historico].slice(0, 5);
    setHistorico(novoHistorico);
    localStorage.setItem('historicoConsultas', JSON.stringify(novoHistorico));
  };

  const carregarHistorico = () => {
    const hist = localStorage.getItem('historicoConsultas');
    if (hist) {
      setHistorico(JSON.parse(hist));
    }
  };

  const consultarDoHistorico = (item) => {
    setTipoConsulta(item.tipo);
    setValorConsulta(item.valor);
  };

  const limparHistorico = () => {
    setHistorico([]);
    localStorage.removeItem('historicoConsultas');
  };

  const copiarLinhaDigitavel = (linha) => {
    navigator.clipboard.writeText(linha);
    alert('Linha digitável copiada!');
  };

  const getPlaceholder = () => {
    switch (tipoConsulta) {
      case '1': return 'ABC1234 ou ABC1D23';
      case '2': return '000.000.000-00';
      case '3': return '00.000.000/0000-00';
      default: return '';
    }
  };

  const formatarMoeda = (valor) => {
    if (valor === 'ND' || !valor) return 'ND';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(parseFloat(valor));
  };

  const formatarData = (data) => {
    if (data === 'ND' || !data) return 'ND';
    if (data.includes('/')) return data;
    try {
      const date = new Date(data);
      return date.toLocaleDateString('pt-BR');
    } catch {
      return data;
    }
  };

  const getTipoLabel = (tipo) => {
    switch (tipo) {
      case '1': return 'Placa';
      case '2': return 'CPF';
      case '3': return 'CNPJ';
      default: return 'Desconhecido';
    }
  };

  const limparFormulario = () => {
    setValorConsulta('');
    setResultado(null);
    setErro(null);
  };

  const handleTipoChange = (novoTipo) => {
    setTipoConsulta(novoTipo);
    setValorConsulta('');
    setResultado(null);
    setErro(null);
  };

  React.useEffect(() => {
    carregarHistorico();
  }, []);

  return (
    <div className="consulta-boleto-container">
      <div className="header">
        <img src={logoProtseg} alt="PROTSEG" className="logo-protseg" />
        <div className="header-row">
          <h2>Consulta de Boletos PROTSEG</h2>
          <button
            type="button"
            className="btn-assistencia"
            onClick={() => setModalAssistenciaAberto(true)}
          >
            🆘 Assistência
          </button>
        </div>
      </div>

      <div className="form-section">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Tipo de Consulta:</label>
            <select
              value={tipoConsulta}
              onChange={(e) => handleTipoChange(e.target.value)}
            >
              <option value="1">🚗 Placa do Veículo</option>
              <option value="2">👤 CPF</option>
              <option value="3">🏢 CNPJ</option>
            </select>
          </div>

          <div className="form-group">
            <label>
              {tipoConsulta === '1' ? 'Placa:' : tipoConsulta === '2' ? 'CPF:' : 'CNPJ:'}
            </label>
            {tipoConsulta === '1' && (
              <input
                type="text"
                value={valorConsulta}
                onChange={(e) => setValorConsulta(e.target.value.toUpperCase())}
                placeholder={getPlaceholder()}
                maxLength="8"
                required
              />
            )}
            {tipoConsulta === '2' && (
              <input
                ref={cpfInputRef}
                type="text"
                value={valorConsulta}
                onChange={(e) => setValorConsulta(e.target.value)}
                placeholder={getPlaceholder()}
                required
              />
            )}
            {tipoConsulta === '3' && (
              <input
                ref={cnpjInputRef}
                type="text"
                value={valorConsulta}
                onChange={(e) => setValorConsulta(e.target.value)}
                placeholder={getPlaceholder()}
                required
              />
            )}
          </div>

          <div className="form-buttons">
            <button type="submit" disabled={loading || loadingVeiculos} className="btn-primary">
              {loading || loadingVeiculos ? '🔄 Consultando...' : '🔍 Consultar'}
            </button>
            <button
              type="button"
              onClick={limparFormulario}
              className="btn-secundario"
              disabled={loading || loadingVeiculos}
            >
              🗑️ Limpar
            </button>
          </div>
        </form>

        {historico.length > 0 && (
          <div className="historico-section">
            <div className="historico-header">
              <h3>📋 Histórico Recente</h3>
              <button onClick={limparHistorico} className="btn-limpar-historico">
                Limpar
              </button>
            </div>
            <div className="historico-lista">
              {historico.map((item, index) => (
                <div
                  key={index}
                  className="historico-item"
                  onClick={() => consultarDoHistorico(item)}
                >
                  <div className="historico-info">
                    <strong>{getTipoLabel(item.tipo)}:</strong> {item.valor}
                  </div>
                  <div className="historico-meta">
                    <span>{item.qtdVeiculos} veículo(s)</span>
                    <span className="historico-data">
                      {new Date(item.data).toLocaleString('pt-BR')}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Modal de resultado boleto */}
      {modalAberto && (
        <div className="modal-overlay" onClick={fecharModal}>
          <div className="modal-conteudo" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Resultado da Consulta</h3>
              <button className="modal-fechar" onClick={fecharModal}>✕</button>
            </div>

            <div className="modal-body">
              {erro && (
                <div className="erro">
                  <strong>❌ Erro:</strong> {erro}
                </div>
              )}

              {resultado && resultado.veiculos && resultado.veiculos.length > 0 && (
                <div className="resultado">
                  <div className="resultado-header">
                    <h3>✅ Resultados ({resultado.veiculos.length} veículo(s))</h3>
                    {resultado.mensagem && <p className="mensagem">{resultado.mensagem}</p>}
                  </div>

                  <div className="veiculos-lista">
                    {resultado.veiculos.map((veiculo, index) => (
                      <div key={index} className="veiculo-card">
                        <div className="veiculo-header">
                          <h4>🚗 {veiculo.placa}</h4>
                          <span className={`status status-${veiculo.status.toLowerCase().replace(/\s/g, '-')}`}>
                            {veiculo.status}
                          </span>
                        </div>

                        <div className="veiculo-info">
                          <div className="info-row">
                            <span className="info-label">Matrícula:</span>
                            <span className="info-value">{veiculo.matricula}</span>
                          </div>

                          <div className="info-row">
                            <span className="info-label">Vencimento:</span>
                            <span className="info-value">{formatarData(veiculo.vencimento)}</span>
                          </div>

                          <div className="info-row">
                            <span className="info-label">Valor:</span>
                            <span className="info-value valor-destaque">
                              {formatarMoeda(veiculo.valor)}
                            </span>
                          </div>

                          {veiculo.linhadigitavel && veiculo.linhadigitavel !== 'ND' && (
                            <div className="linha-digitavel-container">
                              <div className="linha-digitavel-header">
                                <strong>Linha Digitável:</strong>
                                <button
                                  onClick={() => copiarLinhaDigitavel(veiculo.linhadigitavel)}
                                  className="btn-copiar"
                                  title="Copiar linha digitável"
                                >
                                  📋 Copiar
                                </button>
                              </div>
                              <div className="linha-digitavel">
                                {veiculo.linhadigitavel}
                              </div>
                            </div>
                          )}

                          <div className="veiculo-actions">
                            {veiculo.url && veiculo.url !== 'ND' && (
                              <a
                                href={veiculo.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-boleto"
                              >
                                📄 Baixar Boleto PDF
                              </a>
                            )}
                            <button
                              className="btn-pgtos-realizados"
                              onClick={() => consultarPgtosRealizados(veiculo.placa)}
                            >
                              ✅ Pgtos Realizados
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {resultado && resultado.veiculos && resultado.veiculos.length === 0 && (
                <div className="sem-resultados">
                  <div className="sem-resultados-icon">🔍</div>
                  <h3>Nenhum veículo encontrado</h3>
                  {resultado.mensagem && <p>{resultado.mensagem}</p>}
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn-primary btn-nova-consulta" onClick={fecharModal}>
                ← Nova Consulta
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de veículos do associado */}
      {modalVeiculosAberto && (
        <div className="modal-overlay" onClick={fecharModalVeiculos}>
          <div className="modal-conteudo modal-conteudo-veiculos" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🚘 Veículos do Associado</h3>
              <button className="modal-fechar" onClick={fecharModalVeiculos}>✕</button>
            </div>

            <div className="modal-body">
              {erroVeiculos && (
                <div className="erro">
                  <strong>❌ Erro:</strong> {erroVeiculos}
                </div>
              )}

              {resultadoVeiculos && (
                <>
                  {/* Dados do Associado */}
                  {resultadoVeiculos.associado && (
                    <div className="associado-card">
                      <div className="associado-header">
                        <h4>👤 Dados do Associado</h4>
                      </div>
                      <div className="associado-info">
                        <div className="info-row">
                          <span className="info-label">Nome:</span>
                          <span className="info-value">{resultadoVeiculos.associado.nome}</span>
                        </div>
                        <div className="info-row">
                          <span className="info-label">Endereço:</span>
                          <span className="info-value">
                            {resultadoVeiculos.associado.endereco}
                            {resultadoVeiculos.associado.numero ? `, ${resultadoVeiculos.associado.numero}` : ''}
                            {resultadoVeiculos.associado.complemento ? ` - ${resultadoVeiculos.associado.complemento}` : ''}
                          </span>
                        </div>
                        <div className="info-row">
                          <span className="info-label">Cidade/UF:</span>
                          <span className="info-value">
                            {resultadoVeiculos.associado.cidade} - {resultadoVeiculos.associado.uf}
                          </span>
                        </div>
                        <div className="info-row">
                          <span className="info-label">CEP:</span>
                          <span className="info-value">{resultadoVeiculos.associado.cep}</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Lista de Veículos */}
                  {resultadoVeiculos.veiculos && resultadoVeiculos.veiculos.length > 0 ? (
                    <div className="veiculos-associado-section">
                      <h4 className="veiculos-associado-titulo">
                        🚗 Veículos ({resultadoVeiculos.veiculos.length})
                      </h4>
                      <div className="veiculos-lista">
                        {resultadoVeiculos.veiculos.map((veiculo, index) => (
                          <div key={index} className="veiculo-card veiculo-card-associado">
                            <div className="veiculo-header">
                              <h4>🚗 {veiculo.placa}</h4>
                              <div className="veiculo-header-actions">
                                <button
                                  className="btn-consultar-boleto-placa"
                                  onClick={() => consultarBoletoPorPlaca(veiculo.placa)}
                                >
                                  🔍 Consultar Boleto
                                </button>
                                <button
                                  className="btn-pgtos-realizados"
                                  onClick={() => consultarPgtosRealizados(veiculo.placa)}
                                >
                                  ✅ Pgtos Realizados
                                </button>
                              </div>
                            </div>

                            <div className="veiculo-info">
                              <div className="info-row">
                                <span className="info-label">Modelo:</span>
                                <span className="info-value">{veiculo.modelo}</span>
                              </div>
                              <div className="info-row">
                                <span className="info-label">Marca:</span>
                                <span className="info-value">{veiculo.marca}</span>
                              </div>
                              <div className="info-row">
                                <span className="info-label">Ano:</span>
                                <span className="info-value">{veiculo.ano}</span>
                              </div>
                              <div className="info-row">
                                <span className="info-label">Matrícula:</span>
                                <span className="info-value">{veiculo.matricula}</span>
                              </div>
                              <div className="info-row">
                                <span className="info-label">Combustível:</span>
                                <span className="info-value">{veiculo.combustivel}</span>
                              </div>
                              <div className="info-row">
                                <span className="info-label">Valor FIPE:</span>
                                <span className="info-value valor-destaque">
                                  {formatarMoeda(veiculo.valorfipe)}
                                </span>
                              </div>
                              <div className="info-row">
                                <span className="info-label">Cód. FIPE:</span>
                                <span className="info-value">{veiculo.codigofipe}</span>
                              </div>
                              <div className="info-row">
                                <span className="info-label">Dia Vencto:</span>
                                <span className="info-value">{veiculo.diavencto}</span>
                              </div>
                              {veiculo.colaborador && (
                                <div className="info-row">
                                  <span className="info-label">Colaborador:</span>
                                  <span className="info-value">{veiculo.colaborador}</span>
                                </div>
                              )}
                              {veiculo.chassis && (
                                <div className="info-row">
                                  <span className="info-label">Chassi:</span>
                                  <span className="info-value">{veiculo.chassis}</span>
                                </div>
                              )}
                              {veiculo.renavan && (
                                <div className="info-row">
                                  <span className="info-label">Renavan:</span>
                                  <span className="info-value">{veiculo.renavan}</span>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="sem-resultados">
                      <div className="sem-resultados-icon">🔍</div>
                      <h3>Nenhum veículo encontrado</h3>
                    </div>
                  )}
                </>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn-primary btn-nova-consulta" onClick={fecharModalVeiculos}>
                ← Voltar
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Modal Assistência */}
      {modalAssistenciaAberto && (
        <div className="modal-overlay" onClick={() => setModalAssistenciaAberto(false)}>
          <div className="modal-conteudo modal-conteudo-assistencia" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>🆘 Assistência PROTSEG</h3>
              <button className="modal-fechar" onClick={() => setModalAssistenciaAberto(false)}>✕</button>
            </div>
            <div className="modal-body modal-body-assistencia">
              <img src={`${process.env.PUBLIC_URL}/assistencia.png`} alt="Assistência PROTSEG" className="img-assistencia" />
            </div>
          </div>
        </div>
      )}

      {/* Modal Pgtos Realizados - sobrepõe os demais */}
      {modalQuitAberto && (
        <div className="modal-overlay modal-overlay-quit" onClick={fecharModalQuit}>
          <div className="modal-conteudo modal-conteudo-quit" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>✅ Pgtos Realizados — {placaQuit}</h3>
              <button className="modal-fechar" onClick={fecharModalQuit}>✕</button>
            </div>

            <div className="modal-body">
              {loadingQuit && (
                <div className="loading-quit">🔄 Consultando pagamentos...</div>
              )}

              {erroQuit && (
                <div className="erro">
                  <strong>❌ Erro:</strong> {erroQuit}
                </div>
              )}

              {resultadoQuit && Array.isArray(resultadoQuit.titulos) && resultadoQuit.titulos.length > 0 && (
                <div className="titulos-lista">
                  <div className="titulos-header-row">
                    <span>Vencimento</span>
                    <span>Pgto</span>
                    <span>Valor</span>
                  </div>
                  {resultadoQuit.titulos.map((titulo, index) => (
                    <div key={index} className="titulo-card">
                      <div className="titulo-row">
                        <div className="info-row">
                          <span className="info-label">Vencimento:</span>
                          <span className="info-value">{formatarData(titulo.dt_vencto)}</span>
                        </div>
                        <div className="info-row">
                          <span className="info-label">Pgto:</span>
                          <span className="info-value">{formatarData(titulo.dt_pgto)}</span>
                        </div>
                        <div className="info-row">
                          <span className="info-label">Valor:</span>
                          <span className="info-value valor-destaque">{formatarMoeda(titulo.valor)}</span>
                        </div>
                      </div>
                      {titulo.linha_digitavel && titulo.linha_digitavel !== 'ND' && (
                        <div className="linha-digitavel-container">
                          <div className="linha-digitavel-header">
                            <strong>Linha Digitável:</strong>
                            <button
                              onClick={() => copiarLinhaDigitavel(titulo.linha_digitavel)}
                              className="btn-copiar"
                              title="Copiar linha digitável"
                            >
                              📋 Copiar
                            </button>
                          </div>
                          <div className="linha-digitavel">{titulo.linha_digitavel}</div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}

              {resultadoQuit && Array.isArray(resultadoQuit.titulos) && resultadoQuit.titulos.length === 0 && (
                <div className="sem-resultados">
                  <div className="sem-resultados-icon">🔍</div>
                  <h3>Nenhum pagamento encontrado</h3>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button className="btn-primary btn-nova-consulta" onClick={fecharModalQuit}>
                ← Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ConsultaBoleto;
